import i18next from 'i18next'
import * as React from 'react'
import { StandardLocalWidget, any, fromJSX } from 'widgets-for-react'
import { FormControls } from '../../utils/forms'
import { DataLayer, PIIData } from '../../utils/datalayer'
import { ComponentDidMount } from '../../utils/lifecycleMethods'
import {
  Country,
  CountryState,
  countryStateUpdaters,
  emptyCountry,
} from './countryState'

const translateCountry = (title: string) =>
  i18next.t(`allowedSubscriptionCountries:${title}`)

const sortCountriesByLanguage = (language: string, countries: Array<Country>): Array<Country> =>
{
  let filtered = countries.filter(f => language == 'nl' ? f.BusinessCentralCode !== 'NL' && f.BusinessCentralCode !== 'BE' : f.BusinessCentralCode !== 'GB')
  
  if (language == 'nl') {
    const nl = countries.find(f => f.BusinessCentralCode === 'NL')
    const be = countries.find(f => f.BusinessCentralCode === 'BE')
    if (nl !== undefined && be!== undefined)  return [nl, be].concat(filtered)
  }
  const gb = countries.find(f => f.BusinessCentralCode === 'GB')
  if (gb !== undefined) return [gb].concat(filtered)

  return countries
}

export const countryWidget =
  (
    availableCountries: Array<Country>,
    suppressHotjar: boolean,
    readonly?: boolean,
    fieldMessage?: string,
    personalDetailsInUpgradeFlow?: boolean,
    piiData?: PIIData,
    onChange?: (countryId: number) => void
  ): StandardLocalWidget<CountryState> =>
  (currentState) => {
    const translatedCountries = availableCountries.map((item) => ({
      ...item,
      Title: translateCountry(item.Title ?? ''),
    })).sort((a,b) => a.Title.localeCompare(b.Title))
    const countries = sortCountriesByLanguage(i18next.language, translatedCountries);
    const selected =
    countries.find(
        (country) => country.Id === currentState.input.Id
      ) || emptyCountry
    return any([
      currentState.validator
        .widget()
        .map(countryStateUpdaters.validation),
      fromJSX((setState) => (
        <>
          <ComponentDidMount
            onMount={() => {
              if (personalDetailsInUpgradeFlow && selected.Title !== undefined)
                DataLayer.upgradeFlowStep2(
                  'country',
                  piiData,
                  selected.Title
                )
            }}
          />
          <FormControls.FormSelectInGroup
            key="companyCountryChoice"
            controlId="companyCountryChoice"
            label={i18next.t('subscription:Country')}
            readOnly={readonly}
            required={true}
            value={selected.Id?.toString() || ''}
            onChange={(newValue) => {
              const newCountry =
              countries.find(
                  (country) => country.Id?.toString() == newValue
                ) || emptyCountry
              setState(countryStateUpdaters.input(() => newCountry))
              if (
                newCountry.Title !== undefined &&
                personalDetailsInUpgradeFlow
              )
                DataLayer.upgradeFlowStep2(
                  'country',
                  piiData,
                  newCountry.Title
                )

              if (onChange) {
                onChange(newCountry.Id || 0)
              }
            }}
            validation={currentState.validatorResult.path('Id')}
            fieldMessage={fieldMessage}
            suppressHotjar={suppressHotjar}
          >
            {[
              <option value="" disabled={true}>
                {i18next.t('auth:selectPlaceholder', {
                  entity: i18next.t('subscription:Country').toLowerCase(),
                })}
              </option>,
              ...countries.map((country) =>
                country.Id !== undefined && country.Title !== undefined ? (
                  <option value={country.Id}>
                    {country.Title}
                  </option>
                ) : (
                  <></>
                )
              ),
            ]}
          </FormControls.FormSelectInGroup>
        </>
      )),
    ])
  }
